import axiosService from './common/axios'

function searchMenuStatItems (paramData) {
	return axiosService.get('menu/stat/items', { params: paramData })
}

function searchIndexStatCode (paramData) {
	return axiosService.get('index/stat/indexStatCode', { params: paramData })
}

function searchEbarometersList (paramData) {
	return axiosService.get('index/stat/eBarometersList', { params: paramData })
}

function searchEbarometersDtl (paramData) {
	return axiosService.get('index/stat/eBarometersDtl', { params: paramData })
}

function searchMetaInfoList (paramData) {
	return axiosService.get('subject/metaInfoList', { params: paramData })
}

function selectDaIndexList (paramData) {
	return axiosService.get('index/stat/selectDaIndexList', { params: paramData })
}

function selectDaIndexTmeList (paramData) {
	return axiosService.get('index/stat/selectDaIndexTmeList', { params: paramData })
}

function selectDaIndexDataList (paramData) {
	return axiosService.get('index/stat/selectDaIndexDataList', { params: paramData })
}

function selectDaIndexCateTmeList (paramData) {
	return axiosService.get('index/stat/selectDaIndexCateTmeList', { params: paramData })
}

function selectDaIndexCateList (paramData) {
	return axiosService.get('index/stat/selectDaIndexCateList', { params: paramData })
}

function selectDaIndexExTmeList (paramData) {
	return axiosService.get('index/stat/selectDaIndexExTmeList', { params: paramData })
}

function selectDaIndexExList (paramData) {
	return axiosService.get('index/stat/selectDaIndexExList', { params: paramData })
}

function selectDaIndexExDataList (paramData) {
	return axiosService.get('index/stat/selectDaIndexExDataList', { params: paramData })
}

export {
	searchMenuStatItems, searchIndexStatCode, searchMetaInfoList, searchEbarometersList, searchEbarometersDtl, selectDaIndexList, selectDaIndexTmeList
	, selectDaIndexDataList, selectDaIndexCateTmeList, selectDaIndexCateList, selectDaIndexExTmeList, selectDaIndexExList, selectDaIndexExDataList
}
